"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFingerprint = exports.getRawFingerprint = void 0;
const browser_1 = require("./sources/browser");
const timezone_1 = require("./sources/timezone");
const canvas_1 = require("./sources/canvas");
const hash_1 = require("./utils/hash");
const device_1 = require("./sources/device");
const fonts_1 = require("./sources/fonts");
const audio_1 = require("./sources/audio");
const webgl_1 = require("./sources/webgl");
const contrast_1 = require("./sources/contrast");
const color_gamut_1 = require("./sources/color_gamut");
const forced_colors_1 = require("./sources/forced_colors");
const hdr_1 = require("./sources/hdr");
const monochrome_1 = require("./sources/monochrome");
const reducedMotion_1 = require("./sources/reducedMotion");
const math_1 = require("./sources/math");
const getRawFingerprint = () => __awaiter(void 0, void 0, void 0, function* () {
    let browser = yield (0, browser_1.default)();
    let timezone = (0, timezone_1.default)();
    let device = (0, device_1.default)();
    browser.canvas = (0, canvas_1.default)();
    // --- Colours ---
    device.color.contrast = (0, contrast_1.default)();
    device.color.gamut = (0, color_gamut_1.default)();
    device.color.forcedColors = (0, forced_colors_1.default)();
    device.color.hdr = (0, hdr_1.default)();
    device.color.monochromeDepth = (0, monochrome_1.default)();
    return {
        browser,
        device,
        timezone,
        audio: yield (0, audio_1.default)(),
        webgl: (0, webgl_1.default)(),
        reducedMotion: (0, reducedMotion_1.default)(),
        math: (0, math_1.default)(),
        fonts: yield (0, fonts_1.default)()
    };
});
exports.getRawFingerprint = getRawFingerprint;
const getFingerprint = () => __awaiter(void 0, void 0, void 0, function* () {
    let raw = yield (0, exports.getRawFingerprint)();
    return yield (0, hash_1.encode)(JSON.stringify(raw));
});
exports.getFingerprint = getFingerprint;
